import React, { useState } from 'react';
import { ContentSectionWrap } from '../common-styles.styles';

const FaqSection = props => {
  const { faq, isDweb } = props;
  if (!faq) {
    return null;
  }
  const { q: question, a: answer } = faq;
  const [showFaq, setFaq] = useState(false);
  const handlefaqExpand = () => {
    setFaq(!showFaq);
  };
  return (
    <div className="faqSection">
      <p onClick={handlefaqExpand} className="dF alignItemsCenter justifyBetween curPointFlt">
        <span className={`${isDweb ? 'grey font10' : 'font12 fb quicksand black'}`}>
          {question}
        </span>{' '}
        <span className={'faqArrow ' + (showFaq ? 'arrowDown' : '')}></span>
      </p>
      {showFaq && <p className={`grey marginT5 ${isDweb ? 'font10' : 'font12'}`}>{answer}</p>}
    </div>
  );
};

const Faqs = props => {
  const { faqs, isDweb = false } = props;
  if (!faqs) {
    return null;
  }
  return (
    <ContentSectionWrap className="contentGreen" isDweb={isDweb}>
      <div className="marginB15">
        <span className="contentHead quicksand">FAQs</span>
      </div>
      <div className="contentSection">
        {faqs && faqs.map((faq, i) => <FaqSection key={`faq${i}`} faq={faq} isDweb={isDweb} />)}
      </div>
    </ContentSectionWrap>
  );
};
export default Faqs;
